/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Create_Aaf_FailedInputs */



/**
* | output |
* | --- |
* | "There was an error creating the AAF file." |
*
* @param {Subtitle_Export_Create_Aaf_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_create_aaf_failed = /** @type {((inputs?: Subtitle_Export_Create_Aaf_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Create_Aaf_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite lors de la création du fichier AAF.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Erstellen der AAF-Datei ist ein Fehler aufgetreten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore durante la creazione del file AAF.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка при создании файла AAF.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se produjo un error al crear el archivo AAF.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建 AAF 文件时出错。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AAF ファイルの作成中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AAF फाइल बनाने में त्रुटि हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro ao criar o arquivo AAF.")
	return /** @type {LocalizedString} */ ("There was an error creating the AAF file.")
});